import { defineTemplate } from '../../../utils';
import { MACRO_BREADCRUMB_CONFIG } from './config/breadcrumb-config';
import { MACRO_CHANNEL_CONFIG } from './config/channel-config';

const BASE = `${process.env.REACT_APP_MEDIA_DOMAIN}/brands/assets/MACRO/templates/macro-saca-tu-tarjeta/thumbnails`;

export const macroSacaTuTarjeta = defineTemplate({
  mode: 'legacy',
  id: 'macro-saca-tu-tarjeta',
  clientId: 'MACRO',
  handlerKey: 'MACRO',
  title: 'Sacá tu tarjeta',
  hidePromptTemplate: true,
  thumbnail: { url: `${BASE}/optimized/macro-awareness-optimized.png`, aspectRatio: 'vertical' },
  channelConfigs: MACRO_CHANNEL_CONFIG,
  breadcrumbConfig: MACRO_BREADCRUMB_CONFIG,
  formFields: [
    {
      key: 'title',
      label: 'Nombre del proyecto',
      type: 'input',
      placeholder: 'Nombre para identificar este asset',
      required: true
    },
    {
      key: 'stage',
      label: 'Etapa',
      type: 'select',
      required: true,
      defaultValue: 'CONVERSION',
      options: [
        { value: 'AWARENESS', label: 'Awareness' },
        { value: 'CONSIDERACION', label: 'Consideración' },
        { value: 'CONVERSION', label: 'Conversión' }
      ]
    },
    {
      key: 'variant',
      label: 'Motivo',
      type: 'select',
      required: true,
      defaultValue: '1',
      options: [
        { value: '1', label: '1' },
        { value: '2', label: '2' },
        { value: '3', label: '3' },
        { value: '4', label: '4' },
        { value: '5', label: '5' }
      ]
    },
    {
      key: 'adChannel',
      label: 'Medio',
      type: 'select',
      required: true,
      options: [
        { value: 'google', label: 'Google' },
        { value: 'meta', label: 'Meta' }
      ]
    },
    {
      key: 'claim',
      label: 'Titular',
      type: 'rich-text',
      placeholder: `¡Sentite libre!
Pedí tu TARJETA
MACRO hoy`,
      required: true,
      maxLines: 3
    },
    {
      key: 'subheadline_enabled',
      label: 'Incluir bajada',
      type: 'switch',
      required: false,
      defaultValue: 'no',
      valueType: 'string'
    },
    {
      key: 'subheadline',
      label: 'Bajada (Máx. 2 líneas)',
      type: 'input',
      placeholder: 'Más límite para disfrutar tus compras',
      required: false,
      multiline: true
    },
    {
      key: 'cta_enabled',
      label: 'Incluir CTA',
      type: 'switch',
      required: false,
      defaultValue: 'no',
      valueType: 'string'
    },
    {
      key: 'cta_text',
      label: 'Texto del CTA',
      type: 'input',
      placeholder: 'Sacá tu TARJETA',
      required: false,
      defaultValue: ''
    },
    {
      key: 'legal',
      label: 'Incluir legal',
      type: 'switch',
      required: false,
      defaultValue: 'no',
      valueType: 'string'
    }
  ]
});
